import 'stylesheets/pages/event/online_ijuu_center/style';
import SmoothScroll from 'smooth-scroll';

new SmoothScroll('a[href*="#"]', {
  easing: 'easeInOutCubic',
  offset: 20,
  updateURL: false,
  popstate: true,
});

const select = document.querySelector('#filter');
const options = document.querySelectorAll('#filter option');
const param = new URLSearchParams(window.location.search);

select.remove(options.length - 1);

if (param.has('selected')) {
  const index = param.get('selected');
  options[index].selected = true;
}

select.addEventListener('change', () => {
  const index = select.selectedIndex;
  const encodeParam = encodeURIComponent(options[index].value);
  window.location.href = `${window.location.pathname}?selected=${index}&area_name=${encodeParam}#area`;
});
